export default function FiltroReporte({ filtros, setFiltros, onBuscar }) {
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFiltros((prev) => ({ ...prev, [name]: value }));
    };

    return (
        <div className="filters-grid card-panel">
            <input type="date" name="fechaInicio" value={filtros.fechaInicio || ""} onChange={handleChange} />
            <input type="date" name="fechaFin" value={filtros.fechaFin || ""} onChange={handleChange} />
            <input type="text" name="idCuenta" placeholder="Cuenta" value={filtros.idCuenta || ""} onChange={handleChange} />
            <input type="text" name="idCategoria" placeholder="Categoría" value={filtros.idCategoria || ""} onChange={handleChange} />
            <button onClick={onBuscar}>Generar</button>
        </div>
    );
}